import { render, staticRenderFns } from "./send-message.vue?vue&type=template&id=e47db70c&scoped=true"
import script from "./send-message.vue?vue&type=script&lang=ts"
export * from "./send-message.vue?vue&type=script&lang=ts"
import style0 from "./send-message.vue?vue&type=style&index=0&id=e47db70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47db70c",
  null
  
)

export default component.exports